import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import _ from 'lodash';

/* Actions */
import { saveBackOrders, deleteOrderDetails, saveDeletedOrderProductsDetails, saveManageOrdersListBackup } from '../../../redux/actions';

class CancelProducts extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orderDetails: null
		}
	}

	componentWillMount() {
		this.props.saveBackOrders(null);
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		var self = this;
		let orderDetails = self.props.state.order.orderDetails;
		if(orderDetails) {
			orderDetails.responseObject.items = _.filter(orderDetails.responseObject.items, item => {
				return item.lineStatus !== 'CANCELLED';
			});
			self.setState({
				orderDetails: orderDetails
			});
		} else {
			browserHistory.push('/manageorders');
		}
	}

	handleSelect(selectedIndex, event) {
		let orderDetails = this.state.orderDetails,
			self = this;
		orderDetails.responseObject.items.map((item, index) => {
			if(index === selectedIndex) {
				item.markedDelete = event.target.checked
			}
			return null;
		})
		self.setState({
			orderDetails: orderDetails,
			errorMessage: ''
		});
	}

	handleDelete(whatToDelete, event) {
		event.preventDefault();
		let self = this;
		self.setState({
			errorMessage: ''
		})
		let payload = JSON.parse(JSON.stringify(this.state.orderDetails.responseObject));
		payload.items = _.filter(payload.items, ['markedDelete', true]);

		if(whatToDelete === 'cancelProducts' && payload.items.length === 0) {
			self.setState({
				errorMessage: 'Please select at least one product.'
			})
		} else {
			var tempPayload = payload;
			self.props.deleteOrderDetails(payload, 'requestType='+whatToDelete, true, (response) => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					//Save deleted payload into store for showing on confirmation page
					self.props.saveDeletedOrderProductsDetails(tempPayload);

					//Update manage order list data into store as well
					var manageOrdersList = self.props.state.order.manageOrdersListBackup.ordersListResponse;
					if(whatToDelete === 'cancelProducts') {
						manageOrdersList.responseObject.map((item, index) => {
							item.orderHeader.orderNumber === tempPayload.orderNumber && item.orderDetail.orderLine.map((itm, ind) => {
								if(_.find(tempPayload.items, ['item', itm.item])) {
									itm.lineStatus = 'CANCELLED';
								}
								return null;
							})
							return null;
						});

						//remove all orders whose all products has been CANCELLED
						let orderList = [];
						manageOrdersList.responseObject.map((item, index) => {
							let orderLine = _.filter(item.orderDetail.orderLine, itm => {
								return itm.lineStatus !== 'CANCELLED'
							});
							if(orderLine.length > 0) orderList.push(item);
							return null;
						});
						manageOrdersList.responseObject = orderList;

					} else {
						manageOrdersList.responseObject = _.filter(manageOrdersList.responseObject, (item) => {
							return item.orderHeader.orderNumber !== tempPayload.orderNumber
						});
					}
					self.props.saveManageOrdersListBackup({
						...self.props.state.order.manageOrdersListBackup,
						ordersListResponse: {
							...self.props.state.order.manageOrdersListBackup.ordersListResponse,
							responseObject: manageOrdersList.responseObject
						},
						backupOrdersListResponse: {
							...self.props.state.order.manageOrdersListBackup.backupOrdersListResponse,
							responseObject: manageOrdersList.responseObject
						}
					});
					browserHistory.push('/'+whatToDelete+"/confirmation");
				}
			})
		}
	}

    render() {
		let orderDetails = this.state.orderDetails;
		orderDetails = orderDetails && orderDetails.responseObject?orderDetails.responseObject:orderDetails;
        return (
			<div>
				<div>
					<h1 className="pageTitle">Cancel Products</h1>
					<p className="orange">Products that are already shipping cannot be cancelled from this order.</p>
					<h3 style={{marginBottom: 0}}>Select Products To Cancel</h3>
					<p className="bold red">{this.state.errorMessage}</p>
				</div>
				{orderDetails &&
					<div>
						<div className="captionAboveTable" style={{marginTop: 0}}>
							<div className="bold big">
								CSO (Order number): {orderDetails.orderNumber} &nbsp; &nbsp; &nbsp; Order Date: {this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')} &nbsp; &nbsp; &nbsp; P.O. # {orderDetails.poNumber}
							</div>
				        </div>
						<table className="dataTable manageOrdersDeleteProductsTable" width="100%">
							<thead>
								<tr>
									<th className="delProd">Product</th>
									<th className="delProdDesc">Description</th>
									<th className="delProdQuantity">Quantity<br />Ordered</th>
									<th className="delProdStatus">Product<br />Status</th>
									<th className="delProdSelect">Select</th>
								</tr>
							</thead>
							<tbody>
								{orderDetails.items.map((item, index) => {
									if(this.props.getItemTypeByName(item.item) === 'S') {
										return null;
									}
									return <tr key={index}>
										<td className="delProd">{item.item}</td>
										<td className="delProdDesc">{item.itemDescription}</td>
										<td className="delProdQuantity">{item.quantity}</td>
										<td className="delProdStatus">{item.lineStatus}</td>
										<td className="delProdSelect"><input type="checkbox" name={"delprod"+index} disabled={item.cancelable === 'Yes' && item.updatable === 'Yes'?false:true} className="delProductChecks" onClick={this.handleSelect.bind(this, index)}/></td>
									</tr>
								})}
							</tbody>
						</table>
						<div>
							{orderDetails.items && _.filter(orderDetails.items, ['cancelable', 'Yes']).length > 0 &&
								<div style={{float: 'right', textAlign: 'right'}}>
									<span><a className="blueButton blockButton deleteSelectedProducts" href="" onClick={this.handleDelete.bind(this, 'cancelProducts')}>Cancel Selected Products</a></span>
									{_.filter(orderDetails.items, ['cancelable', 'Yes']).length === orderDetails.items.length &&
										<span>
											<h3>OR</h3>
											<span><a className="blueButton blockButton deleteEntireOrder" href="" onClick={this.handleDelete.bind(this, 'cancelOrder')}>Cancel Entire Order</a></span>
										</span>
									}
								</div>
							}
							<p><Link to={"/manageorders"}>Return to Previous Screen</Link></p>
							<div className="clear" />
						</div>
					</div>
				}
	      	</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	deleteOrderDetails: (payload, queryStringParams, showLoader, callback) => dispatch(deleteOrderDetails(payload, queryStringParams, showLoader, callback)),
	saveDeletedOrderProductsDetails: (deletedOrderObj) => dispatch(saveDeletedOrderProductsDetails(deletedOrderObj)),
	saveManageOrdersListBackup: (data) => dispatch(saveManageOrdersListBackup(data)),
	saveBackOrders: (data) => dispatch(saveBackOrders(data)),
})

CancelProducts = connect(mapStateToProps, mapDispatchToProps)(CancelProducts);
export default CancelProducts;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/cancelProducts.js